/* eslint-disable react-hooks/exhaustive-deps */
import { useMediaQuery } from "react-responsive";
import { observer } from "mobx-react-lite";
import { FormInput } from "../../../components/ui/Form/FormInput";
import { useForm } from "react-hook-form";
import appStore from "../../../stores/appStore";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../../components/ui/Button";
import accountStore from "../store/accountStore";
import { toast, ToastContainer } from "react-toastify";
import { useState } from "react";
import { FormInputMask } from "../../../components/ui/Form/FormInputMask";

export interface IAccountSettings {
  name: string;
  surname: string;
  email?: string;
}

const AccountSettings = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [isLoading, setIsLoading] = useState(false);

  const mobileStyles = {
    container: isMobile ? "flex-col p-2 gap-2" : "flex-row p-[20px] gap-[20px]",
    sidebar: isMobile
      ? "flex-row w-full overflow-x-auto gap-4 p-2 bg-white rounded-lg"
      : "flex-col rounded-2xl h-max bg-white p-[20px] gap-[20px] min-w-[250px] shadow-[0_2px_20px_#0000001a]",
    menuItem: isMobile
      ? "text-base whitespace-nowrap"
      : "text-[18px] tracking-[-0.02em]",
    content: isMobile ? "w-full mt-2" : " w-full text-[#232323]",
    form: isMobile ? "flex flex-col gap-[15px]" : "flex flex-col gap-[20px]",
    formRow: isMobile ? "flex flex-col gap-[15px]" : "flex flex-row gap-[20px]",
  };

  const formSchema = yup.object().shape({
    name: yup.string().trim().required("Имя обязательно"),
    surname: yup.string().trim().required("Фамилия обязательна"),
    email: yup.string().email().optional(),
  });

  const onSubmit = async (data: IAccountSettings) => {
    console.log(data);
    setIsLoading(true);
    const response = await accountStore.setSettings(data);

    if (response.new_values) {
      toast.success("Данные успешно изменены!", {
        position: "bottom-right",
        autoClose: 300,
      });
    }
    console.log(appStore.userInfo);

    setValue("name", response.new_values.name || appStore.userInfo.name || "");
    setValue(
      "surname",
      response.new_values.surname || appStore.userInfo.surname || ""
    );
    setValue(
      "email",
      response.new_values.email || appStore.userInfo.email || ""
    );

    setIsLoading(false);
  };

  const {
    handleSubmit,
    register,
    formState: { errors },
    //  setError,
    //  clearErrors,
    //  watch,
    //  trigger,
    setValue,
    //  getValues,
  } = useForm<IAccountSettings>({
    defaultValues: {
      name: appStore.userInfo.name ?? "",
      surname: appStore.userInfo.surname ?? "",
      email: appStore.userInfo.email ?? "",
    },
    resolver: yupResolver(formSchema),
    mode: "onChange",
  });

  return (
    <div className={`flex flex-col gap-[20px] ${mobileStyles.content}`}>
      {!isMobile && (
        <h2 className={`${isMobile ? " " : "text-[20px]"} font-semibold`}>
          Настройки аккаунта
        </h2>
      )}

      <div
        className={`bg-white ${
          isMobile
            ? "flex-col  p-[15px] justify-center items-center gap-[20px] whitespace-nowrap bg-[rgba(255, 255, 255, 1)] rounded-[20px] shadow-[0_2px_20px_#0000001a]"
            : "rounded-[20px] p-[30px] shadow-[0_2px_20px_#0000001a]"
        }  w-full`}
      >
        <div className={!isMobile ? "max-w-[844px] w-max over": 'w-full'} >
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={mobileStyles.form}
          >
            <div className={mobileStyles.formRow}>
              <FormInput
                label="Имя"
                classNameForm={isMobile ? "w-full" : "w-[400px]"}
                className={`${isMobile ? "h-[50px]" : "h-[49px]"} !p-[15px]`}
                placeholder="Введите имя"
                {...register("name", { required: "Имя обязательно" })}
                error={errors.name?.message}
                disabled={isLoading || !appStore.isLoginIn}
                defaultValue={appStore.userInfo.name || ""}
              />
              <FormInput
                label="Фамилия"
                classNameForm={isMobile ? "w-full" : "w-[400px]"}
                className={`${isMobile ? "h-[50px]" : "h-[49px]"} !p-[15px]`}
                placeholder="Введите фамилию"
                {...register("surname")}
                error={errors.surname?.message}
                disabled={isLoading || !appStore.isLoginIn}
                defaultValue={appStore.userInfo.surname || ""}
              />
            </div>
            <div>
              <FormInputMask
                classNameForm={isMobile ? "w-full" : "w-[400px] "}
                className={isMobile ? "h-[50px]" : "h-[49px]"}
                label="Телефон"
                mask="+7 (000) 000-00-00"
                placeholder="+7 (___) ___ - __ - __"
                //   {...register("phone", {
                //     required: "Телефон обязателен",
                //   })}
                //   error={errors.phone?.message}
                disabled
                value={appStore.userInfo.phone}
                defaultValue={appStore.userInfo.phone}
              />
            </div>
            <div className="mb-[57px]">
              <FormInput
                label="E-mail"
                classNameForm={isMobile ? "w-full" : "w-[400px]"}
                className={`${isMobile ? "h-[50px]" : "h-[49px]"} !p-[15px]`}
                placeholder="Введите e-mail"
                {...register("email")}
                error={errors.email?.message}
                disabled={isLoading || !appStore.isLoginIn}
                defaultValue={appStore.userInfo.email || ""}
              />
            </div>
            <Button
              type="submit"
              className={!isMobile ? "self-start h-[59px] w-[310px] !rounded-[15px] ": ' h-[59px] w-full !rounded-[15px]'}
              disabled={isLoading}
            >
              {isLoading ? "Отправка..." : "Сохранить"}
            </Button>
          </form>
        </div>
      </div>
                   {isMobile && (
      <Button
        onClick={() => appStore.logout()}
        style="secondary"
        className="!bg-transparent !text-[#B21913] !text-left !p-0 !pl-[20px]"
      >
        Выйти из аккаунта
      </Button>
        )
      }
      <ToastContainer></ToastContainer>
    </div>
  );
};

export default observer(AccountSettings);
